import { Stack, Text } from "@mantine/core";

export default function Rules() {
  return (
    <Stack px="md">
      <Text size="sm" ta="justify">
        • کلیه فعالیت‌های سایت مطابق با قوانین وموازین کشور می‌باشد و هرگونه
        .تخطی از آن عواقب بعدی را برای مخاطب در برخواهد داشت
      </Text>
      <Text size="sm" ta="justify">
        • در صورت تغییر قیمت از سوی نهادهای مرجع و اپراتورها، هزینه‌ی ارسال
        پیامک‌های خریداری شده با قیمت جدید محاسبه خواهد شد.
      </Text>
      <Text size="sm" ta="justify">
        • هرگونه ارسال پیامک با مضامین زیر ممنوع بوده و در صورتی که این موارد
        مشاهده شود علاوه بر مسدود نمودن پنل، در صورت درخواست سازمان‌ها و یا
        ارگان‌های مرتبط تمامی اطلاعات فرد خاطی ارائه خواهد شد.
      </Text>
      <Text size="sm" ta="justify" pr="xl">
        – ارسال هرگونه پیامک غیرمتعارف، نظیر شکایت، جوک‌های نامتعارف، برنده شدن
        جایزه به هر نوعی، و دریافت اطلاعات بانکی یا مشخصات اشخاص، ارسال پیامک
        سیاسی (با مجوز یا بدون مجوز)، ارسال سایت‌های شرط بندی، ارسال پیامک حاوی
        شماره کارت و شماره حساب ( بدون مجوز)، هرگونه پیامک غیراخلاقی و هرگونه
        پیامکی که باعث تشویش اذهان عمومی شود.
      </Text>
      <Text size="sm" ta="justify">
        • در زمان ثبت نام شما موظف می‌باشید که اطلاعات دقیق وارد نمایید و پس از
        آن مدارک لازم را به صورت واقعی آپلود نمایید. در صورت استفاده از مشخصات
        شخص دیگری در سامانه، تبعات قانونی آن متوجه شما خواهد بود.
      </Text>
      <Text size="sm" ta="justify">
        • تمامی اطلاعات خود را به صورت صحیح وارد نمایید. درصورتی که اطلاعات
        اشتباهی توسط شما اعلام شود، علاوه بر مسدود نمودن پنل، شرکت این حق را
        برای خود محفوظ می‌دارد که در صورت نیاز از مراجع قانونی پیگیری‌های لازم
        را انجام دهد.
      </Text>
      <Text size="sm" ta="justify">
        • در صورتی که بر اثر استفاده ناصحیح از سامانه پیامک ضرر و زیانی متوجه
        شخص شود شرکت هیچ گونه تعهدی نسبت به آن نخواهد داشت و بازگشت هزینه صورت
        نمی‌گیرد.
      </Text>
      <Text size="sm" ta="justify">
        • هرگونه نفوذ دراطلاعات سایت و یا سعی و تلاش برای ایجاد اختلال در عملکرد
        سامانه پیامک غیرقانونی بوده و با متخلفان برخورد خواهد شد.
      </Text>
      <Text size="sm" ta="justify">
        • شرکت تمام تلاش خود را برای جلوگیری از نفوذ هکرها و همچنین حفظ و
        نگهداری اطلاعات شما به صورت خصوصی انجام می دهد. اطلاعات شما به هیچ عنوان
        توسط شرکت مورد استفاده قرار نخواهد گرفت.
      </Text>
      <Text size="sm" ta="justify">
        • در زمان‌هایی که اپراتورهای ارائه دهنده سرویس دچار مشکل می‌شوند و امکان
        ارسال و دریافت پیامک مقدور نمی‌باشد، شرکت اطلاع رسانی‌های لازم را انجام
        خواهد داد. اما از آنجا که این اختلالات بدون اطلاع قبلی انجام می‌شود ممکن
        است در برخی موارد این قطعی ها با تاخیر اطلاع رسانی شود.
      </Text>
      <Text size="sm" ta="justify">
        • شرایط اختصاصی سامانه :
      </Text>
      <Text size="sm" pr="xl">
        – ارائه اطلاعات نادرست شخص استفاده کننده : در صورتی که اطلاعات استفاده
        کننده از سامانه به صورت صحیح اعلام نشود و به نحوی سامانه با اطلاعات غلط
        فعال گردد و این مورد برای کارشناسان محرز گردد، این حق برای سایت محفوظ
        خواهد بود که بلافاصله سامانه شخص خاطی را غیرفعال نموده و تا ارائه مدارک
        مستند و قابل اتکا، سامانه ایشان را به هیچ عنوان فعال نکند.
      </Text>
      <Text size="sm" ta="justify">
        • رعایت محتوای پیامکهای ارسالی : پیامک تبلیغاتی نوعی اطلاعرسانی عمومی بر
        روی بستر مخابرات محسوب می گردد که سازمان تنظیمات و مقررات رادیویی متولی
        کنترل آن محسوب می گردد. لذا در همین راستا قوانینی برای محتوای پیامکهای
        ارسالی تنظیم نموده است که رعایت آنها برای استفاده کنندگان از این خدمات
        ضروری و لازم است :{" "}
      </Text>
      <Text size="sm" pr="xl">
        – محتوای پیامک نباید شامل تبلیغ و معرفی کالاها و خدماتی باشد که طبق
        قوانین کشور ممنوع اعلام شده است.
      </Text>
      <Text size="sm" pr="xl">
        – محتوای پیامک نباید شامل تبلیغ و معرفی کالاهای غیراخلاقی و جنسی باشد.
      </Text>
      <Text size="sm" pr="xl">
        – محتوای پیامک نباید شامل مبارزات انتخاباتی بر علیه کاندیداهای دیگر
        باشد.
      </Text>
      <Text size="sm" pr="xl">
        – محتوای پیامک نباید شامل جعل اخبار، انتشار اکاذیب و اطلاعات غلط باشد.
      </Text>
      <Text size="sm" pr="xl">
        – محتوای پیامک نباید شامل مواردی باشد که باعث تشویش اذهان عمومی شود.
      </Text>
      <Text size="sm" pr="xl">
        – محتوای پیامک نباید شامل مواردی باشد که نظم عمومی جامعه را بر هم می
        زند.{" "}
      </Text>
      <Text size="sm" pr="xl">
        – محتوای پیامک نباید شامل مواردی باشد که برخلاف قوانین عمومی کشور است.
      </Text>
      <Text size="sm" pr="xl">
        – محتوای پیامک نباید شامل مواردی باشد که مطابق با قوانین کشور و اسلام
        نیست.
      </Text>
      <Text size="sm" ta="justify">
        • برخی از مواردی که باید در هنگام ارسال از درج آنها در متن خودداری نمود
        :
      </Text>
      <Text size="sm" pr="xl">
        – ارسال جک های غیراخلاقی.
      </Text>
      <Text size="sm" pr="xl">
        – ارسال پیامکهایی با مضمون برنده شدن و دریافت جایزه.
      </Text>
      <Text size="sm" pr="xl">
        – ارسال پیامکهایی که حاوی ناسزا، فحش و کلمات نامتعارف است.{" "}
      </Text>
      <Text size="sm" ta="justify">
        • برخی از تبلیغاتی که با توجه به حساسیت، نیازمند اخذ مجوز رسمی ارسال می
        باشند:
      </Text>
      <Text size="sm" pr="xl">
        – تبلیغات لوازم آرایشی و بهداشتی.{" "}
      </Text>
      <Text size="sm" pr="xl">
        – تبلیغات هرگونه فعالیتی که مرتبط با سلامت جسم و روح (درمانی و پزشکی) می
        باشد.{" "}
      </Text>
      <Text size="sm" pr="xl">
        – تبلیغات هرگونه کالای ویژه بزرگسالان.{" "}
      </Text>
      <Text size="sm" pr="xl">
        – تبلیغات هرگونه کالای مرتبط با امور جنسی.{" "}
      </Text>
      <Text size="sm" pr="xl">
        – تبلیغات مرتبط با مراکز آرایشی و بهداشتی.
      </Text>
      <Text size="sm" pr="xl">
        – تبلیغات برای فروش ملک و زمین بدون داشتن پروانه کسب.{" "}
      </Text>{" "}
      <Text size="sm" ta="justify">
        • برای ارسال پیامکهای حوزه پزشکی و درمانی باید مجوزات لازم در دفتر اسناد
        رسمی برابر اصل گردند و برای ارائه به اپراتور ارائه گردند.
      </Text>
      <Text size="sm" ta="justify" bg="yellow.2" py="xs">
        • شارژ انجام شده در سامانه پیام کوتاه به دلیل انجام امور مالی و مالیاتی،
        تنها پس از ۷ روز قابل بازگشت خواهد بود.
      </Text>
      <Text size="sm" ta="justify">
        • شرایط عمومی :
      </Text>
      <Text size="sm" pr="xl">
        – بر اساس ماده ۲۱ قانون جرایم رایانه ای، رعایت موارد زیر در محتوای پیامک
        الزامی خواهد بود:
      </Text>
      <Text size="sm" pr="xl">
        – الف) محتوای پیامک نباید خلاف عفت و اخلاق جامعه باشد:
      </Text>
      <Text size="sm" pr="xl">
        – هرگونه اشاعه فحشا، تحریک، تشویق و یا دعوت به فساد، انتشار و توزیع
        هرگونه محتوای مبتذل و مستهجن و تحقیر و توهین به زنان از جمله خط قرمزهای
        محتوای پیامک می باشد.{" "}
      </Text>
      <Text size="sm" pr="xl">
        – هرگونه راه اندازی مراکز همسریابی به صورت آنلاین در فشای مجازی، الزاما
        باید با مجوز دریافتی از وزارت ورزش و جوانان صورت پذیرد.
      </Text>
      <Text size="sm" ta="justify">
        • ب) محتوای پیامک نباید علیه مقدسات اسلامی باشد:
      </Text>
      <Text size="sm" pr="xl">
        – هرگونه محتوای خلاف موازین اسلامی، توهین به دین و مقدسات، اهانت و توهین
        به هر یک از انبیا و ائمه طاهرین، تبلیغات برای گروه و یا حزب مخالف اسلام
        و اهانت به رهبری از جمله مواردی است که مشاهده هر یک از آنها در متن
        پیامک، تبعات بعدی در بر خواهد داشت.
      </Text>
      <Text size="sm" ta="justify">
        • ج) محتوای پیامک نباید خلاف امنیت و آسایش عمومی جامعه باشد:
      </Text>
      <Text size="sm" pr="xl">
        – تشکیل گروه در فضای مجازی برای بر هم زدن نظم و امنیت، انتشار محتوا علیه
        قانون اساسی، اخلال در وحدت ملی، انتشار غیرمجاز اسرار دولتی و نیروهای
        مسلح از جمله مواردی است که رعایت نکردن آنها تبعات بعدی در بر خواهد داشت.
      </Text>
      <Text size="sm" ta="justify">
        • د) محتوای پیامک نباید علیه مقامات و نهادهای دولتی و عمومی باشد.{" "}
      </Text>
      <Text size="sm" ta="justify">
        • ه) محتوای پیامک نباید شامل موارد زیر باشد:{" "}
      </Text>
      <Text size="sm" pr="xl">
        – انتشار و توزیع نرم افزاری هایی که صرفا برای ارتکاب اعمال مجرمانه
        استفاده می گردد.
      </Text>
      <Text size="sm" pr="xl">
        – انتشار رمز عبور و اطلاعاتی که امکان دسترسی غیرمجاز به داده های سازمانی
        را فراهم می کند.s
      </Text>
      <Text size="sm" pr="xl">
        – انتشار و آموزش هرگونه محتوای مربوط به چگونگی نفوذ، شنود و … از مراکز
        رایانه ای و مخابراتی{" "}
      </Text>
      <Text size="sm" pr="xl">
        – انتشار فیلترشکن وراههای عبور از فیلترینگ
      </Text>
      <Text size="sm" pr="xl">
        – انتشار و تبلیغ مراکز قمار در فضای مجازی{" "}
      </Text>
      <Text size="sm" pr="xl">
        – انتشار و تبلیغ پایگاههای اینترنتی بانکها و سازمانها{" "}
      </Text>
      <Text size="sm" ta="justify">
        • و) محتوای پیامک نباید تحریک، ترغیب و یا دعوت به ارتکاب جرم نماید.{" "}
      </Text>
    </Stack>
  );
}
